import React, { useEffect, useState } from 'react';
import { freepikService } from '../../../services';

export default function IconPickerModal({ open, onClose, onSelectIcon }) {
  const [query, setQuery] = useState('marketing');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;

    const run = async () => {
      setLoading(true);
      setError('');
      const result = await freepikService.searchIcons({ q: query, page: 1 });

      if (!result?.success) {
        setItems([]);
        setError(result?.message || 'Não foi possível carregar ícones');
      } else {
        setItems(result.items || []);
      }
      setLoading(false);
    };

    run();
  }, [open, query]);

  if (!open) return null;

  return (
    <div className="manual-modal" role="dialog" aria-modal="true" aria-label="Selecionar ícone Freepik">
      <div className="manual-modal__card">
        <header className="manual-modal__header">
          <h3>Ícones Freepik</h3>
          <button type="button" className="manual-modal__close" onClick={onClose}>Fechar</button>
        </header>

        <div className="manual-modal__search">
          <input
            type="text"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Buscar ícones..."
          />
        </div>

        <div className="manual-modal__grid manual-modal__grid--icons">
          {loading && <p>Carregando...</p>}
          {!loading && error && <p>{error}</p>}
          {!loading && !error && items.map((item) => (
            <button
              key={`icon-${item.id || item.svg_url}`}
              type="button"
              className="manual-modal__item manual-modal__item--icon"
              onClick={() => {
                onSelectIcon(item.svg_url || item.thumb || '');
                onClose();
              }}
            >
              <img src={item.thumb || item.svg_url} alt={item.title || 'Ícone'} loading="lazy" />
              <span>{item.title || 'Ícone'}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
